export const CONSTANTS = {
  RECEIVE_TOKEN_SUCCESS: 'RECEIVE_TOKEN_SUCCESS',
  RECEIVE_NOTIFICATIONS_SUCCESS: 'RECEIVE_NOTIFICATIONS_SUCCESS',
  NOTIFY_EXPORT_SUCCESS: 'NOTIFY_EXPORT_SUCCESS',
  NOTIFY_EXPORT_ERROR: 'NOTIFY_EXPORT_ERROR',
  NOTIFY_PAY_INVOICE_PENDING: 'NOTIFY_PAY_INVOICE_PENDING',
  NOTIFY_PAY_INVOICE_SUCCESS: 'NOTIFY_PAY_INVOICE_SUCCESS',
  NOTIFY_PAY_INVOICE_ERROR: 'NOTIFY_PAY_INVOICE_ERROR',
  NOTIFY_WEBSOCKET_MESSAGE_SUCCESS: 'NOTIFY_WEBSOCKET_MESSAGE_SUCCESS',
  NOTIFICATION_DELAY: 150,
  PDF_TYPE_INVOICE_EXPORT_PDF: 'invoice_export_pdf',
  FETCH_PROFILE_DETAILS_REQUEST: 'FETCH_PROFILE_DETAILS_REQUEST',
  FETCH_PROFILE_DETAILS_SUCCESS: 'FETCH_PROFILE_DETAILS_SUCCESS',
  FETCH_PROFILE_DETAILS_FAILURE: 'FETCH_PROFILE_DETAILS_FAILURE',
  PROVIDER_AUTHENTICATION_REQUEST: 'PROVIDER_AUTHENTICATION_REQUEST',
  PROVIDER_ATHENTICATION_SUCCESS: 'PROVIDER_AUTHENTICATION_SUCCESS',
  PROVIDER_ATHENTICATION_FAILURE: 'PROVIDER_AUTHENTICATION_FAILURE',
};

export const NOTIFICATION_EVENTS = [
  CONSTANTS.NOTIFY_EXPORT_SUCCESS,
  CONSTANTS.NOTIFY_WEBSOCKET_MESSAGE_SUCCESS,
  CONSTANTS.NOTIFY_PAY_INVOICE_PENDING,
  CONSTANTS.NOTIFY_PAY_INVOICE_SUCCESS,
  CONSTANTS.NOTIFY_PAY_INVOICE_ERROR,
];
